<div class="video-preview">
    <video #video autoplay loop [src]="movie | fileUrl : 'RESOURCES' : false" (loadstart)="video.muted = true">
        {{'system.error.video' | translate}}
    </video>
</div>
